import React from 'react'
import Icon from 'components/ui/icon'
import Text from 'components/ui/text'
import styles from './index.module.css'

/**
 * A component that displays an error message with an error icon in a row layout
 * @param text - The error message text to display
 * @returns A div containing an error icon and the error message text
 */
const ErrorRow = ({ text }: { text: string }): React.ReactElement<'div'> => {
  return (
    <div className={styles.errorRowErrorContainer}>
      <Icon type="error" />

      <Text type="paragraph">{text}</Text>
    </div>
  )
}

export default ErrorRow
